import React, { Component } from "react";
import {
  Panel,
  Modal,
  Button
}                           from "react-bootstrap";
import _                    from "lodash";
import axios                from "axios";
import FileSaver            from "file-saver";
import moment               from "moment";
import {
  ToastContainer,
  toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import { PHOENIXVOUCHER }        from "actions/const";

import { IS_VALID }         from "utils";

import saveTrail            from "../../utils/saveTrail";

import CrudComponent        from "./../zynappse-crud";
import PhoenixVoucherSchema      from "./PhoenixVoucherSchema";
import FormContainer        from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class PhoenixVoucher extends Component {
  constructor (props) {
    super(props);

    this.getPhoenixVoucherRedemptionLog = this.getPhoenixVoucherRedemptionLog.bind(this);
    this.getAllPhoenixVoucherRedemptionLog = this.getAllPhoenixVoucherRedemptionLog.bind(this);
    this.exportReport = this.exportReport.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  getPhoenixVoucherRedemptionLog (currentPage = 1, memberIds = [], cardTypes = [], startDate = "", endDate = "") {
    let {
      PhoenixVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      countType,
      limit
    } = PhoenixVoucher;

    let isShowMerchantsOwnRedemptionOnly = false,
        evScannerUserConfig;
    
    let user = Parse.User.current();

    if (
      IS_VALID(user) &&
      IS_VALID(user.get("userType"))
    ) {
      if (user.get("userType") === "MERCHANT") {
        isShowMerchantsOwnRedemptionOnly = selectedData.get("isShowMerchantsOwnRedemptionOnly") || false;
      } else if (user.get("userType") === "PARTNER") {
        isShowMerchantsOwnRedemptionOnly = true;

        if (Array.isArray(user.get("evScannerUserConfig"))) {
          evScannerUserConfig = user.get("evScannerUserConfig");
        }
      }
    } 
  
    let memberIdArray = memberIds.map((item) => item.value),
        cardTypeArray = cardTypes.map((item) => item.value);

    actions.setValue(PHOENIXVOUCHER, { isLoading: true });

    new Promise((resolve, reject) => {
      if (countType === "VIEWED") {
        let query = new Parse.Query("PhoenixVoucherRedemption");

        query.include([ "PhoenixVoucher.title" ]);
        query.equalTo("PhoenixVoucher", selectedData);
        query.descending("createdAt");

        query.skip((currentPage - 1) * limit);
        query.limit(limit);

        if (memberIdArray.length !== 0) {
          query.containedIn("memberId", memberIdArray);
        }

        if (cardTypeArray.length !== 0) {
          query.containedIn("cardType", cardTypeArray);
        }

        if (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.greaterThanOrEqualTo("createdAt", moment(startDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        if (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.lessThanOrEqualTo("createdAt", moment(endDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        let totalRecord = _.clone(query);
        totalRecord.skip(0);
        totalRecord.limit(-1);

        resolve(Promise.all([
          query.find(),
          totalRecord.count()
        ]));
      } else if (countType === "CLAIMED" || countType === "REDEEMED") {
        let query = new Parse.Query("PhoenixVoucherRedemptionLog");

        // query.equalTo("status", countType);
        let sortColumnName = "";

        if (countType === "CLAIMED") {
          query.exists("dateClaimed");
          sortColumnName = "dateClaimed";
        } else {
          query.exists("dateRedeemed");
          sortColumnName = "dateRedeemed";

          if (isShowMerchantsOwnRedemptionOnly) {
            if (evScannerUserConfig) {
              query.containedIn("User", evScannerUserConfig.map((id) => new Parse.User({ id })));
            } else {
              query.equalTo("User", user);
            }
          }
        }

        query.include([ "User" ]);
        query.descending(sortColumnName);

        query.equalTo("PhoenixVoucher", selectedData);

        query.skip((currentPage - 1) * limit);
        query.limit(limit);

        if (memberIdArray.length !== 0) {
          query.containedIn("memberId", memberIdArray);
        }

        if (cardTypeArray.length !== 0) {
          query.containedIn("cardType", cardTypeArray);
        }

        if (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.greaterThanOrEqualTo(sortColumnName, moment(startDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        if (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
        ) {
          query.lessThanOrEqualTo(sortColumnName, moment(endDate, "MMM DD, YYYY hh:mm A", true).toDate());
        }

        let totalRecord = _.clone(query);
        totalRecord.skip(0);
        totalRecord.limit(-1);

        resolve(Promise.all([
          query.find(),
          totalRecord.count()
        ]));
      }
    })
    .then(([ data, count ]) => {
      actions.setValue(
        PHOENIXVOUCHER,
        {
          isLoading: false,
          tableData: data,
          totalCount: count
        }
      );
    })
    .catch((err) => {
      console.log("error: ", err);
    });
  }

  getAllPhoenixVoucherRedemptionLog (selectedData, currentPage = 1) {
    return new Promise((resolve, reject) => {
      let limit = 10;

      let query = new Parse.Query("PhoenixVoucherRedemptionLog");
  
      query
      .include([ "PhoenixVoucher",])
      .equalTo("PhoenixVoucherRedemption", selectedData)
      .skip((currentPage - 1) * limit)
      .limit(limit)
      .descending("createdAt");
  
      let totalRecord = _.clone(query);
  
      totalRecord
      .skip(0)
      .limit(-1);
  
      Promise.all([
        query.find(),
        totalRecord.count()
      ])
      .then(resolve)
      .catch(reject);
    });
  }

  exportReport (memberIds = [], cardTypes = [], startDate = "", endDate = "") {
    let {
      PhoenixVoucher,
      actions
    } = this.props;

    let {
      selectedData,
      countType
    } = PhoenixVoucher;

    actions.setValue(PHOENIXVOUCHER, { isExporting: true });

    let isShowMerchantsOwnRedemptionOnly = false,
        evScannerUserConfig,
        isHideFinanceData = false;

    let user = Parse.User.current();

    if (
      IS_VALID(user) &&
      IS_VALID(user.get("userType"))
    ) {
      if (user.get("userType") === "MERCHANT") {
        isShowMerchantsOwnRedemptionOnly = selectedData.get("isShowMerchantsOwnRedemptionOnly") || false;
      } else if (user.get("userType") === "PARTNER") {
        isShowMerchantsOwnRedemptionOnly = true;

        if (Array.isArray(user.get("evScannerUserConfig"))) {
          evScannerUserConfig = user.get("evScannerUserConfig");
        }

        isHideFinanceData = typeof user.get("isHideFinanceData") === "boolean" ? user.get("isHideFinanceData") : false;
      }
    }

    axios({
      method: "post",
      url: WEB_PATH + "/PhoenixVoucher/export",
      data: {
        phoenixVoucherId: selectedData.id,
        reportType: countType,
        evScannerUserId: isShowMerchantsOwnRedemptionOnly ? (evScannerUserConfig ? evScannerUserConfig : user.id) : "",
        memberIdArray: memberIds.map((item) => item.value),
        cardTypeArray: cardTypes.map((item) => item.value),
        startDate: (
          IS_VALID(startDate) &&
          moment(startDate, "MMM DD, YYYY hh:mm A", true).isValid()
          ? (
            moment(startDate, "MMM DD, YYYY hh:mm A", true).format()
          ) : (
            ""
          )
        ),
        endDate: (
          IS_VALID(endDate) &&
          moment(endDate, "MMM DD, YYYY hh:mm A", true).isValid()
          ? (
            moment(endDate, "MMM DD, YYYY hh:mm A", true).format()
          ) : (
            ""
          )
        ),
        isHideFinanceData
      },
      responseType: "arraybuffer"
    })
    .then((res) => {
      let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
      FileSaver.saveAs(blob, `${countType === "VIEWED" ? "ENROLLED" : countType} Calypso Voucher Report ${moment().format("MMM-DD-YYYY")}.xlsx`);

      actions.setValue(PHOENIXVOUCHER, { isExporting: false });
    })
    .catch((err) => {
      console.log("exportReport error: ", err);
      actions.setValue(PHOENIXVOUCHER, { isExporting: false });
    });
  }

  loadOptions (input = "", cb, className = "MemberDetail") {
    let query = new Parse.Query(className),
        objItem;
    if (className === "MemberDetail") {
      query
      .matches("memberId", input, "i")
      .ascending("memberId")
      .exists("memberId");

      objItem = (item) => {
        return {
          label: item.get("memberId"),
          value: item.get("memberId")
        };
      };
    } else if (className === "VoucherCardType") {
      query
      .matches("name", input, "i")
      .ascending("name");

      objItem = (item) => {
        return {
          label: item.get("name"),
          value: item.get("name")
        };
      };
    }

    query.limit(10);

    query.find()
    .then((data) => {
      cb(
        null,
        {
          options: data.map(objItem)
        }
      );
    })
    .catch((err) => {
      cb(
        null,
        {
          options: []
        }
      );
    })
  }
  
  accessible (actionType) {
    let {
      access
    } = this.props.accessjson;

    if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
  }

  render () {
    let {
      PhoenixVoucher,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      isRedeemingEVoucher,
      formType
    } = PhoenixVoucher;

    let moduleQuery = [
      { method: "descending", column: "createdAt" },
      { method: "notEqualTo", column: "status", value: "DRAFT" }
    ];

    let schema = PhoenixVoucherSchema;

    let user = Parse.User.current();

    if (IS_VALID(user) && IS_VALID(user.get("userType"))) {
      if (user.get("userType") === "MERCHANT") {
        moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: [user] });
      } else if (user.get("userType") === "VIP HOST") {
        moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: [] });
      } else if (user.get("userType") === "PARTNER") {
        if (Array.isArray(user.get("evScannerUserConfig"))) {
          moduleQuery.push({ method: "containedIn", column: "evScannerUser", value: user.get("evScannerUserConfig").map((id) => new Parse.User({ id })) });
        }
      }

      if (user.get("userType") !== "ADMIN") {
        let indexOfTotalJoined = PhoenixVoucherSchema.columns.map((item) => item.columnName).indexOf("totalJoined");

        if (indexOfTotalJoined !== -1) {
          let clone = {
            ...PhoenixVoucherSchema,
            columns: [...PhoenixVoucherSchema.columns]
          }
          clone.columns.splice(indexOfTotalJoined, 1);

          schema = clone;
        }
      }
    }

    let crudProps = {
      schema: schema,
      access: accessjson.access,
      moduleQuery: moduleQuery,
      customItems: [
        {
          columnName: "title",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "totalJoined",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      PHOENIXVOUCHER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "VIEWED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "totalClaimed",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      PHOENIXVOUCHER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "CLAIMED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        },
        {
          columnName: "totalRedeemed",
          render: ({ value, column, getTableData, object }) => {
            let renderValue = 0;

            if (IS_VALID(value) && value !== 0) {
              renderValue = (
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    actions.setValue(
                      PHOENIXVOUCHER,
                      {
                        showModal: true,
                        selectedData: object,
                        formType: "VIEW",
                        countType: "REDEEMED"
                      }
                    );
                  }}
                  >
                  {value}
                </a>
              );
            }

            return renderValue;
          }
        }
      ]
    };

    let formContainerProps = {
      ...this.props,
      getPhoenixVoucherRedemptionLog: this.getPhoenixVoucherRedemptionLog,
      getAllPhoenixVoucherRedemptionLog: this.getAllPhoenixVoucherRedemptionLog,
      exportReport: this.exportReport,
      loadOptions: this.loadOptions,
      accessible: this.accessible
    };

    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>Calypso Voucher</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
          bsSize={"lg"}
          backdrop={formType.toUpperCase() === "VIEW" ? "static" : null}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction || !isRedeemingEVoucher) {
              actions.setValue(
                PHOENIXVOUCHER,
                {
                  showModal: false
                }
              );
            }
          }}>
          <Modal.Header closeButton>
            <Modal.Title>{formType.toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            <Button
              disabled={isLoadingAction || isRedeemingEVoucher}
              onClick={() => {
                if (!isLoadingAction || !isRedeemingEVoucher) {
                  actions.setValue(
                    PHOENIXVOUCHER,
                    {
                      showModal: false
                    }
                  );
                }
              }}
              >
                CLOSE
              </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer />
      </div>
    );
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	var {
		accessjson,
    PhoenixVoucher
	} = state;

	const props = {
		accessjson,
    PhoenixVoucher
	};
	return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoenixVoucher);



// WEBPACK FOOTER //
// ./components/PhoenixVoucher/index.js